<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'FilePreviewGalleryDialogToolbar',
  mixins: [baseMixin],
  props: {
    canDownloadFile: {
      type: Boolean,
    },
    fileName: {
      type: String,
      default: '',
    },
  },
  computed: {
    compStyle() {
      return {
        position: 'absolute',
        right: this.isSmallOrLower ? 0 : '20px',
        'z-index': 20,
      }
    },
  },
}
</script>

<template>
  <v-toolbar dark class="transparent" flat width="100%" :style="compStyle">
    <slot>
      <v-spacer />

      <v-tooltip v-if="canDownloadFile" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            data-testid="file-preview-gallery-dialog-download-btn"
            dark
            text
            outlined
            class="mr-4"
            style="text-transform: initial"
            v-on="on"
            @click.prevent.stop="$emit('download')"
          >
            <span>{{
              fileName | truncateText(isMediumOrLower ? 30 : 60)
            }}</span>
          </v-btn>
        </template>
        <span>{{ $t('general.download') }}</span>
      </v-tooltip>
      <p
        v-else
        class="mb-0 mr-4"
        data-testid="file-preview-gallery-dialog-file-name-no-download"
      >
        {{ fileName | truncateText(isMediumOrLower ? 30 : 60) }}
      </p>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            dark
            data-testid="file-preview-gallery-dialog-toolbar-close-btn"
            v-on="on"
            @click.prevent.stop="$emit('closed')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('general.close') }}</span>
      </v-tooltip>
    </slot>
  </v-toolbar>
</template>
